import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { t } from 'i18next';

import { tKeys } from '@/i18n';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);

export const formatDateToCET = (isoDate: string) => {
  return dayjs(isoDate).tz('CET').format('ddd, MMM D, h.mma [CET]');
};

export const isDateNowInWeekPeriodFromStartDate = (
  startISODate: string,
  endISODate: string | undefined,
) => {
  const startWeekDate = dayjs(startISODate);
  const endWeekDate = dayjs(endISODate);
  const currentDate = dayjs();

  return endISODate
    ? currentDate.isSameOrAfter(startWeekDate) &&
        currentDate.isSameOrBefore(endWeekDate)
    : currentDate.isSameOrAfter(startWeekDate);
};

export const isDateIsNowOrInFuture = (isoDate: string) =>
  dayjs(isoDate).isSameOrAfter(dayjs());

export const isDateSameOrAfter = (isoDate: string) =>
  dayjs().isSameOrAfter(dayjs(isoDate));

export const countdown = (countDownInput: Date | string): string => {
  const MSEC_IN_SEC = 1000;
  const MSEC_IN_M = 1000 * 60;
  const MSEC_IN_H = 1000 * 60 * 60;
  const MSEC_IN_DAY = 1000 * 60 * 60 * 24;
  const getFirstLatter = (string: string) => string.slice(0, 1).toLowerCase();

  const countDownDate =
    typeof countDownInput === 'string'
      ? new Date(countDownInput)
      : countDownInput;

  const now = new Date(Date.now()).getTime();

  const distance = countDownDate.getTime() - now;

  const days = Math.floor(distance / MSEC_IN_DAY);
  const hours = Math.floor((distance % MSEC_IN_DAY) / MSEC_IN_H);
  const minutes = Math.floor((distance % MSEC_IN_H) / MSEC_IN_M);
  const seconds = Math.floor((distance % MSEC_IN_M) / MSEC_IN_SEC);

  return `${days ? days + `${getFirstLatter(t(tKeys.days))} ` : ''}${
    hours + `${getFirstLatter(t(tKeys.h))}:`
  }${minutes + `${getFirstLatter(t(tKeys.min))}:`}${
    seconds + `${getFirstLatter(t(tKeys.sec))}`
  }`;
};
